import { useQuery } from '@apollo/client';
import { FC } from 'react';
import { lookupCountryQuery } from './country-view-country-query';
import { Country } from '../../types/country';
import { Descriptions } from 'antd';

interface CountryViewProps {
  countryCode: string[] | string;
  label?: string;
  title?: string | React.ReactNode;
  layout?: "vertical" | "horizontal";
  extra?: React.ReactNode;
}

export const CountryView: FC<CountryViewProps> = (props) => {
  const { data: countryData } = useQuery(lookupCountryQuery, {
    context: { clientName: 'unauthorized' }
  });
  const getCountryName = (countryCode: string) => {
    const country = countryData?.countries?.eventPayload?.countries?.find((item: Country) => item.countryCode === countryCode);
    return country ? country.countryName : null;
  };
  return (
    <Descriptions
    title={props.title}
    layout={props.layout}
    labelStyle={{fontSize: '13px'}}
    extra={props.extra}>
      <Descriptions.Item label={props.label ?? 'Country'} >
        {Array.isArray(props.countryCode) ? (
          <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
            {props.countryCode.map(getCountryName).filter(Boolean).map((countryName, index) => (
            <li key={`${getCountryName(countryName ?? '')}-${index}`}>{countryName}</li>
          ))}
        </ul>)
        : (
          <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
            <li key={`${getCountryName(props.countryCode ?? '')}`}>{getCountryName(props.countryCode)}</li>
          </ul>
        )}
      </Descriptions.Item>
  </Descriptions>
);
};


